module.exports = __webpack_public_path__ + "static/img/top1.e24de4c7.png";